import { connect } from 'react-redux';
import React, { Component } from "react";
import ReactTable from "react-table";
import { utils } from '../../helpers';
import {
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Card,
  CardTitle,
  CardBody,
  CardHeader,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Input,
  Form,
  FormGroup,

} from "reactstrap";
import { Button } from "components";
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import { loopbackActions } from "../../actions";
import ArchiveChooser from "./ArchiveChooser";
import { Column } from "cp-react-tree-table";
import VerticalDots from "../../assets/img/vertical_dots";
import { withTranslation } from 'react-i18next';
import { throws } from 'assert';
import Moment from 'react-moment';
import moment from 'moment';
import SwitchOn from 'assets/img/switch-on.jsx';
import SwitchOff from 'assets/img/switch-off.jsx';
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

import ErrorModal from "../Components/ErrorModal"
import { loopbackService } from '../../services';
var QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");


class Trend extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
    }
  }

  componentWillMount() {
    this.fetchData();
  }

  async fetchData() {

    try {

      const { t } = this.props;

      const projectId = localStorage.getItem('selectedProjectId');

      let { item, devices, instances, indexes } = this.props;

      devices = devices.instances;

      let macAddress = "", periferalCode = "";

      for (let device of devices) {

        if (item.type == 0) {
          if (device.cabinetId == item.id) {
            macAddress = device.macAddress;
            break;
          }
        }

        else if (item.type == 1 || item.type == 3 || item.type == 4) {
          // if (device.cabinetId == item.cabinetId) {
          //   macAddress = device.macAddress;
          // }
          if (device.lightPointId == item.id) {
            macAddress = device.macAddress;
            periferalCode = ('0000' + device.addressCode.toString(16).toUpperCase()).slice(-4);
            break;
          }
        }
      }

      let language = "it";
      let user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        language = user.language;
      }

      let model = "", parameters = { projectId, macAddress };

      if (item.type == 0) {
        model = 'cabinets';
        // macAddress del device padre e periferalCode?
        parameters = {
          ...parameters,
          macAddress,
          language: language,
          strPeriod: t('Periodo'),
          strWeekes: t('Settimane'),
          strTotalPowerAndCurrents: t('Potenza totale e corrente'),
          strAndrosInternalVoltage: t('Tensioni interne Andros'),
          strTemperature: t('Temperatura'),
          strManagedPeripherals: t('Periferiche gestite'),
          strWattmeters: t('Wattmetri'),
          strDigitalIO: t('I/O Digitali'),
          strAnalogIO: t('I/O Analogici'),
          strModem: t('Modem'),
          strLineVoltage: t('Tensione fase'),
          strVoltages: t('Tensioni di fase'),
          strLineCurrent: t('Corrente linea'),
          strCurrents: t('Correnti di linea'),
          strLinePower: t('Potenza fase'),
          strPowers: t('Potenze attive di fase'),
          strCounterActiveEnergy: t('Contatore energia attiva'),
          strConsumptionActiveEnergy: t('Energia consumata'),
          strEnergy: t('Energia'),
          strDigitalInputs: t('Ingressi digitali'),
          strDigitalOutputs: t('Uscite digitali'),
          strAnalogInputs: t('Ingressi analogici'),
          strAnaloglOutputs: t('Uscite analogiche'),
          strPeripheralCode: t('Codice periferica'),
          strSignal: t('Segnale'),
          strInfo: t('Informazioni'),
          strGroups: t('Gruppi')
        }

      }
      else if (item.type == 1 || item.type == 3 || item.type == 4) {
        model = 'lightpoints';
        // macAddress del device padre e periferalCode?
        parameters = {
          ...parameters,
          periferalCode,
          language: language,
          strPeriod: t('Periodo'),
          strWeekes: t('Settimane'),
          strDimmerAndPower: t('Dimmer lampada e potenza'),
          strCurrent: t('Corrente'),
          strVoltage: t('Tensione'),
          strTemperature: t('Temperatura'),
          strPower: t('Potenza'),
          strDimmer: t('Dimmer'),
          strDateAndTime: t('Data e ora'),
          strLegend: t('Legenda')
        }

      }

      let url = await loopbackService.invoke('plant', model, 'getdashboardurl', null, language);

      //console.log('getdashboardurl = ',url);

      const height = (window.innerHeight * 85 / 100) + "px";

      const width = this.refs.dashboardContainer.clientWidth + "px";

      if (url.error) {
        this.setState({ errors: [url.error] });
        return;
      }

      var options = {
        url: url.embedUrl,
        container: this.refs.dashboardContainer,
        parameters,
        scrolling: "auto",
        height,
        width
      };

      var dashboard = QuickSightEmbedding.embedDashboard(options);
    } catch (error) {
      this.setState({ errors: [error] })
    }
  }
  render() {

    const { t, item, handleTrendClose } = this.props;
    const { error } = this.state;

    return (
      <Modal
        isOpen={true}
        className="fullscreen-modal-dialog"
        size="lg"
      >
        <ModalHeader
          className=""
        // toggle = {handleConfigClose}
        >
          {error && <ErrorModal error={error} onClickHandler={() => { this.setState({ error: null }) }} />}
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ flex: 1, color: "gray" }}>
              {t("Misure") + " - " + (item.type == 0 ? t('Cabinet') : t('SYRAS')) + " " + item.label}
            </span>
            <Button
              onClick={handleTrendClose}
              icon neutral
              style={{ right: 0, top: 0, position: "relative", flex: 0, }}
            >
              <i style={{ color: "lightgray", fontSize: 28 }} className="fa fa-times"></i>
            </Button>
          </div>

        </ModalHeader>
        <ModalBody >
          <div ref="dashboardContainer" style={{ margin: 0, padding: 0, width: "100%" }} ></div>
        </ModalBody>
      </Modal>

    )

  }



}

function mapStateToProps(state) {
  const { authentication, loopback } = state;
  return {
    authentication,
    configurations: loopback.configurations
  };
}


export default Trend = withTranslation()(connect(mapStateToProps)(Trend));


// WEBPACK FOOTER //
// ./src/views/Navigator/Trend.jsx